import {FormCardSection} from '@/components/ui/form-atoms/FormAtoms'
import {PlannedAccessesAbsenceTotalDetails} from '@/features/planned-accesses/components/planned-accesses-absence-total-details/PlannedAccessesAbsenceTotalDetails'
import {PlannedAccessesThresholdDetails} from '../planned-accesses-threshold-details/PlannedAccessesThresholdDetails'
import {AssistiveRegimeEnum} from '@/features/projects/types'
import {PatientAgeRange} from '@/types'

interface PlannedAccessesProjectCountersCardProps {
    assistiveRegime: AssistiveRegimeEnum | null
    serviceType: Exclude<PatientAgeRange, 'evolutionary_age_adults'> | null
    totalInPresenceAccessCount: number
    totalAbsencesAccessesCount: number
    selectedAbsenceThresholdPercentage: number
}

export const PlannedAccessesProjectCountersCard = ({
    totalInPresenceAccessCount,
    totalAbsencesAccessesCount,
    selectedAbsenceThresholdPercentage,
    assistiveRegime,
    serviceType
}: PlannedAccessesProjectCountersCardProps) => {
    return (
        <FormCardSection columns={2} padding={3}>
            <PlannedAccessesAbsenceTotalDetails
                totalAbsencesAccessesCount={totalAbsencesAccessesCount}
                totalInPresenceAccessesCount={totalInPresenceAccessCount}
                selectedAbsenceThresholdPercentage={selectedAbsenceThresholdPercentage}
                showPercentage
                showPercentageIncidence
                showZeroValue
            />
            <PlannedAccessesThresholdDetails
                assistiveRegime={assistiveRegime}
                serviceType={serviceType}
                totalInPresenceAccessesCount={totalInPresenceAccessCount}
            />
        </FormCardSection>
    )
}
